import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { requestFailure } from '../error/error.actions';
import { requestComplete } from '../../globals/request-queue/request-queue.actions';
import { LoggingService } from '../../services/logging.service';

@Injectable({ providedIn: 'any' })
export class ErrorEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly loggingService: LoggingService,
    ) {}

    onError$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(requestFailure),
                map((error) => {
                    this.loggingService.log({
                        message: 'Request Failure Action Dispatched',
                        level: 'Warn',
                        tags: ['request-failure'],
                        additionalInfo: [{ name: 'Error', value: error }],
                    });

                    return requestComplete({
                        traceId: 'ERROR',
                    });
                }),
            ),
        {
            dispatch: true,
        },
    );
}
